import Vue from 'vue'
import Router from 'vue-router'

import DefaultLayout from '@/layouts/defaultLayoutNew.vue'
import AnonymousLayout from '@/layouts/loginLayoutNew.vue'
import PlainLayout from '@/layouts/plainLayout.vue'
import RouteGuard from '@/services/middleware'
import commercialDefaultLayout from '@/layouts/commercial/defaultLayout.vue'

const CommercialHome = () =>
	import('@/commercial/pages/home.vue')

const CommercialBusiness = () =>
	import('@/commercial/pages/business.vue')

const CommercialWorks = () =>
	import('@/commercial/pages/works.vue')

const CommercialRate = () =>
	import('@/commercial/pages/rate.vue')

const CommercialAboutus = () =>
	import('@/commercial/pages/aboutus.vue')

const CommercialContact = () =>
	import('@/commercial/pages/contact.vue')

const CommercialPrivacy = () =>
	import('@/commercial/pages/privacy.vue')
const PrivacyBusiness = () =>
	import('@/commercial/pages/businessprivacy.vue')
const PromotionTermsAndConditions = () =>
	import('@/commercial/pages/promotermsandconditions.vue')

const CommercialWorksbiz = () =>
	import('@/commercial/pages/worksbiz.vue')

const CommercialPromotion = () =>
	import('@/commercial/pages/promotion.vue')

const CommercialFAQ = () => import('@/commercial/pages/faq.vue')
const CommercialBusinessFAQ = () => import('@/commercial/pages/faqbusiness.vue')

const LegalSecurityAwareness = () => import('@/commercial/pages/securityawareness.vue')


const Login = () => import('@/pages/Account/loginFinal.vue')
const Dashboard = () => import('@/pages/dashboardMain.vue')

const ForgotPassword = () => import('@/pages/Account/ForgotPasswordNew.vue')
const ForgotPasswordConfirm = () => import('@/pages/Account/ConfirmForgotPassword.vue')

const MailValidation = () => import('@/pages/Account/MailValidation.vue')

const Session = () => import('@/pages/Account/SessionDetect.vue')

const IncreaseLimit = () => import('@/pages/Account/IncreaseLimit.vue')
const IncreaseLimitDashboard = () => import('@/pages/Account/IncreaseLimitDashboard.vue')
const ChangePhone = () => import('@/pages/Account/ChangePhoneNew.vue')
const ChangeEmail = () => import('@/pages/Account/ChangeEmailNew.vue')
const ChangePassword = () => import('@/pages/Account/ChangePasswordNew.vue')
const Profile = () => import('@/pages/Account/ProfileNew.vue')
const Registration = () => import('@/pages/Account/RegistrationNew.vue')
const ConfirmPhoneNumber = () => import('@/pages/Account/ConfirmPhoneNumberNew.vue')
const CompleteRegistration = () => import('@/pages/Account/CompleteRegistrationNew.vue');

const ResetPassword = () => import('@/pages/Account/ResetPassword.vue')


const Recipient = () => import('@/pages/Recipient/RecipientNew.vue')
const AddRecipient = () => import('@/pages/Recipient/AddRecipient.vue')
const MerchantradeRecipient = () => import('@/pages/Recipient/MerchantradeRecipientWithUPNew.vue')
const WURecipient = () => import('@/pages/Recipient/WesternUnionRecipient.vue')
const VDRecipient = () => import('@/pages/Recipient/VisaDirectRecipient.vue')

const Transaction = () => import('@/pages/transaction/transactionNew.vue')
const TransactionHistory = () => import('@/pages/transaction/transactionHistoryNew.vue')
const TransactionRefund = () => import('@/pages/transaction/transactionRefund.vue')
const TransactionReprocess = () => import('@/pages/transaction/TransactionReprocess.vue')
const WuAmendTransaction = () => import('@/pages/transaction/wuAmend.vue')



const TransactionConfirmation = () =>
	import('@/pages/transaction/TransactionConfirmationNew.vue')
const TransactionConfirmationBC = () =>
	import('@/pages/transaction/TransactionConfirmationBC.vue')
const TransactionDetail = () =>
	import('@/pages/transaction/transactionDetail.vue')
const TransactionOtp = () =>
	import('@/pages/transaction/transactionOtp.vue')

const TransactionEKYCOTP = () => import('@/pages/transaction/TransactionEKYCOTPNew.vue')

const KYCDetail = () => import('@/pages/KYCDetail.vue')
const EKYCDetail = () => import('@/pages/EKYCDetail.vue')
const UpgradeToKYCDetail = () => import('@/pages/UpgradeToKYCDetail.vue')
const UpgradeToKYC = () => import('@/pages/Account/UpgradeToKYC.vue')
const EkycDocument = () => import('@/pages/Account/EkycDocument.vue')
const Unsubscribe = () => import('@/pages/Account/UnSubscribe.vue')

const EkycCustomerBankDetail = () =>
	import('@/pages/Account/EKYCCustomerBankDetail.vue')

const CustomerOccupationIdIssueDateUpdate = () =>
	import('@/pages/Account/customerOccupationIdIssueDateUpdate.vue')

const ChangePassPhrase = () =>
	import('@/pages/Account/changePassPhrase.vue')

const RegisterPassPhrase = () =>
	import('@/pages/Account/registerPassPhrase.vue')

const UpdatePassPhrase = () =>
	import('@/pages/Account/updatePassPhrase.vue')

const DebitCard = () => 
	import('@/pages/Account/DebitCard.vue')

const EInvoiceTransactionList = () => import('@/pages/transaction/EInvoiceTransactionList.vue')

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
};

Vue.use(Router);

Vue.use(Router)
export default new Router({
	mode: 'history',
	linkActiveClass: 'open active',
	scrollBehavior: () => ({
		y: 0
	}),
	routes: [{
			path: '/',
			redirect: '/home',
			component: DefaultLayout,
			children: [
				{
					path: 'dashboard',
					name: 'Dashboard',
					component: Dashboard,
					props: true,
					beforeEnter: RouteGuard.checkAccess,
					meta: {
						bodyClass: 'web-application'
					}
				}, {
					path: 'changephone',
					name: 'ChangePhone',
					component: ChangePhone,
					props: true,
					beforeEnter: RouteGuard.checkAccess,
					meta: {
						bodyClass: 'web-application'
					}
				}, {
					path: 'increaselimit',
					name: 'IncreaseLimit',
					component: IncreaseLimit,
					props: true,
					beforeEnter: RouteGuard.checkAccess,
					meta: {
						bodyClass: 'web-application'
					}
				},
				{
					path: 'increaselimitdashboard',
					name: 'IncreaseLimitdashboard',
					component: IncreaseLimitDashboard,
					props: true,
					beforeEnter: RouteGuard.checkAccess,
					meta: {
						bodyClass: 'web-application'
					}
				},
				{
					path: 'changeemail',
					name: 'ChangeEmail',
					component: ChangeEmail,
					beforeEnter: RouteGuard.checkAccess,
					meta: {
						bodyClass: 'web-application'
					}
				},
				{
					path: 'changepassword',
					name: 'ChangePassword',
					component: ChangePassword,
					beforeEnter: RouteGuard.checkAccess,
					meta: {
						bodyClass: 'web-application'
					}
				},
				{
					path: 'updatepassphrase',
					name: 'UpdatePassPhrase',
					component: UpdatePassPhrase,
					beforeEnter: RouteGuard.checkAccess,
					meta: {
						bodyClass: 'web-application'
					}
				},
				{
					path: 'changepassphrase',
					name: 'ChangePassPhrase',
					component: ChangePassPhrase,
					beforeEnter: RouteGuard.checkAccess,
					meta: {
						bodyClass: 'web-application'
					}
				},
				{
					path: 'debitcards',
					name: 'debitcards',
					component : DebitCard,
					beforeEnter: RouteGuard.checkAccess,
					meta: {
						bodyClass: 'web-application'
					}
				},
				{
					path: 'ekyccustomerbankdetail',
					name: 'ekyccustomerbankdetail',
					component: EkycCustomerBankDetail,
					beforeEnter: RouteGuard.checkAccess,
					meta: {
						bodyClass: 'web-application'
					}
				},
				{
					path: 'updatecustomer',
					name: 'updatecustomer',
					component: CustomerOccupationIdIssueDateUpdate,
					beforeEnter: RouteGuard.checkAccess,
					meta: {
						bodyClass: 'web-application'
					}
				},


				{
					path: 'profile',
					name: 'Profile',
					component: Profile,
					beforeEnter: RouteGuard.checkAccess,
					meta: {
						bodyClass: 'web-application'
					}
				},
				{
					path: 'registration/complete',
					name: 'CompleteRegistration',
					component: CompleteRegistration,
					beforeEnter: RouteGuard.checkAccess,
					meta: {
						bodyClass: 'web-application'
					}
				}, {
					path: '/upgradetokyc',
					name: 'upgradetokyc',
					component: UpgradeToKYC,
					beforeEnter: RouteGuard.checkAccess,
					meta: {
						bodyClass: 'web-application'
					}

				},
				{
					path: '/ekycdocument',
					name: 'ekycdocument',
					component: EkycDocument,
					beforeEnter: RouteGuard.checkAccess,
					meta: {
						bodyClass: 'web-application'
					}

				},
				{
					path: 'recipient',
					name: "Recipient",
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [{
							path: '',
							component: Recipient,
							props: true,
							beforeEnter: RouteGuard.checkAccess,
							meta: {
								bodyClass: 'web-application'
							}
						},
						{
							path: 'add',
							name: 'AddRecipient',
							component: AddRecipient,
							props: true,
							beforeEnter: RouteGuard.checkAccess,
							meta: {
								bodyClass: 'web-application'
							}

						},
						{
							path: 'merchantrade/:mode',
							name: 'AddRecipient',
							component: MerchantradeRecipient,
							props: true,
							beforeEnter: RouteGuard.checkAccess,
							meta: {
								bodyClass: 'web-application'
							}

						},
						{
							path: ':mode',
							name: 'ModewiseRecipient',
							component: Recipient,
							props: true,
							beforeEnter: RouteGuard.checkAccess,
							meta: {
								bodyClass: 'web-application'
							}

						},

						{
							path: 'merchantrade/:mode/:paymode/:id',
							name: 'ModifyRecipient',
							component: MerchantradeRecipient,
							props: true,
							meta: {
								bodyClass: 'web-application'
							}
						},
						{
							path: 'merchantrade/:mode/:paymode/:id/:txnrefno',
							name: 'SaveRecipientAndReprocesss',
							component: MerchantradeRecipient,
							props: true,
							meta: {
								bodyClass: 'web-application'
							}
						},
						{
							path: 'westernunion/:mode',
							name: 'AddWesternUnionRecipient',
							component: WURecipient,
							props: true,
							beforeEnter: RouteGuard.checkAccess,
							meta: {
								bodyClass: 'web-application'
							}

						},
						{
							path: 'westernunion/:mode/:id',
							name: 'ModifyWesternUnionRecipient',
							component: WURecipient,
							props: true,
							meta: {
								bodyClass: 'web-application'
							}
						},
						{
							path: 'westernunion/:mode/:paymode/:id/:txnrefno',
							name: 'SaveWesternUnionRecipientAndReprocesss',
							component: WURecipient,
							props: true,
							meta: {
								bodyClass: 'web-application'
							}
						},
						{
							path: 'visadirect/:mode',
							name: 'AddVisaDirectRecipient',
							component: VDRecipient,
							props: true,
							beforeEnter: RouteGuard.checkAccess,
							meta: {
								bodyClass: 'web-application'
							}

						},
						{
							path: 'visadirect/:mode/:id',
							name: 'ModifyVisaDirectRecipient',
							component: VDRecipient,
							props: true,
							meta: {
								bodyClass: 'web-application'
							}
						},
						{
							path: 'visadirect/:mode/:paymode/:id/:txnrefno',
							name: 'SaveVisaDirectRecipientAndReprocesss',
							component: VDRecipient,
							props: true,
							meta: {
								bodyClass: 'web-application'
							}
						}
					]
				},
				{
					path: '/transaction',
					name: 'Transaction',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [{
							path: '',
							name: 'TransactionHistory',
							component: TransactionHistory,
							props: true,
							beforeEnter: RouteGuard.checkAccess,
							meta: {
								bodyClass: 'web-application'
							}
						},
						{
							path: 'confirmation/:txnrefno',
							name: 'TransactionConfirmation',
							component: TransactionConfirmation,
							props: true,
							beforeEnter: RouteGuard.checkAccess,
							meta: {
								bodyClass: 'web-application'
							}

						},
						{
							path: 'confirmationbc/:txnrefno',
							name: 'TransactionConfirmationBC',
							component: TransactionConfirmationBC,
							props: true,
							beforeEnter: RouteGuard.checkAccess,
							meta: {
								bodyClass: 'web-application'
							}

						},
						{
							path: 'otp',
							name: 'Transactionotp',
							component: TransactionOtp,
							props: true,
							beforeEnter: RouteGuard.checkAccess,
							meta: {
								bodyClass: 'web-application'
							}
						},
						{
							path: 'ekycotp',
							name: 'ekycotp',
							component: TransactionEKYCOTP,
							props: true,
							beforeEnter: RouteGuard.checkAccess,
							meta: {
								bodyClass: 'web-application'
							}
						},
						{
							path: 'detail/:txnrefno',
							name: 'TransactionDetail',
							component: TransactionDetail,
							props: true,
							beforeEnter: RouteGuard.checkAccess,
							meta: {
								bodyClass: 'web-application'
							}

						},
						{
							path: 'amend/:txnrefno',
							name: 'WuAmendTransaction',
							component: WuAmendTransaction,
							props: true,
							beforeEnter: RouteGuard.checkAccess,
							meta: {
								bodyClass: 'web-application'
							}

			},
			{
			  path: 'reprocess/:txnrefno',
			  name: 'Transactionreprocess',
			  component: TransactionReprocess,
			  props: true,
			  beforeEnter: RouteGuard.checkAccess,
			  meta: { bodyClass: 'web-application' }
			},
			{
				path: 'reprocess/:txnrefno/:onbehalfid',
				name: 'Transactionreprocess',
				component: TransactionReprocess,
				props: true,
				beforeEnter: RouteGuard.checkAccess,
				meta: { bodyClass: 'web-application' }
			  },
			{
			  path: 'refund/:id',
			  name: 'TransactionRefund',
			  component: TransactionRefund,
			  props: true,
			  beforeEnter: RouteGuard.checkAccess,
			  meta: { bodyClass: 'web-application' }
			},
			{
			  path: ':beneficiaryid/:payoutmodeid',
			  name: 'SendMoney',
			  component: Transaction,
			  props: true,
			  beforeEnter: RouteGuard.checkAccess,
			  meta: { bodyClass: 'web-application' }
			},
			{
				path: 'visa/:payoutmodeid/:status/:inquiryorderid',
				name: 'VisaSendMoney',
				component: Transaction,
				props: true,
				beforeEnter: RouteGuard.checkAccess,
				meta: { bodyClass: 'web-application' }
			},
			{
			  path: ':beneficiaryid/:payoutmodeid/:transactionrefno',
			  name: 'ResendEremitPay',
			  component: Transaction,
			  props: true,
			  beforeEnter: RouteGuard.checkAccess,
			  meta: { bodyClass: 'web-application' }
			}
		  ]
		},
		{
			path: '/einvoicetransactionlist',
			name: 'E-Invoce',
			component: {
				render(c) {
					return c('router-view')
				}
			},
			children: [{
					path: '',
					name: 'EInvoiceTransactionList',
					component: EInvoiceTransactionList,
					props: true,
					beforeEnter: RouteGuard.checkAccess,
					meta: {
						bodyClass: 'web-application'
					}
				}
			]
		}
	  ]
	},
	{
	  path: '/account',
	  name: 'Account',
	  component: AnonymousLayout,
	  redirect: '/account/login',
	  children: [
		{
		  path: 'login',
		  name: 'Login',
		  component: Login,
		  meta: { bodyClass: 'web-application' }
		},
		{
		  path: 'forgotpassword',
		  name: 'ForgotPassword',
		  component: ForgotPassword,
		  meta: { bodyClass: 'web-application' }
		},
		{
		  path: 'confirmforgotpassword/:id',
		  name: 'ForgotPasswordConfirm',
		  component: ForgotPasswordConfirm,
		  meta: { bodyClass: 'web-application' }
		},
		{
		  path: 'session',
		  name: 'session',
		  component: Session,
		  meta: { bodyClass: 'web-application' }
		},
		{
		  path: 'mailvalidation',
		  name: 'MailValidation',
		  component: MailValidation,
		  meta: { bodyClass: 'web-application' }
		},
		{
		  path: 'resetpassword',
		  name: 'ResetPassword',
		  component: ResetPassword,
		  meta: { bodyClass: 'web-application' }
		},
		{
		  path: 'registration/initial',
		  name: 'RegistrationInitial',
		  component: Registration,
		  meta: { bodyClass: 'web-application' }
		},
		{
		  path: 'registration/initial/:referralcode',
		  name: 'RegistrationInitialWithReferralCode',
		  component: Registration,
		  props: true,
		  meta: { bodyClass: 'web-application' }

				},
				{
					path: 'registration/phoneconfirm/:id',
					name: 'PhoneNumberConfirm',
					component: ConfirmPhoneNumber,
					props: true,
					meta: {
						bodyClass: 'web-application'
					}
				},
				{
					path: 'registration/passphrase/:id',
					name: 'RegisterPassPhrase',
					component: RegisterPassPhrase,
					props: true,
					meta: {
						bodyClass: 'web-application'
					}
				},
			]
		},

		{
			path: '/unsubscribe',
			name: 'unsubscribe',
			component: AnonymousLayout,
			children: [{
				path: '',
				name: 'EmailUnsubscribe',
				component: Unsubscribe,
				meta: {
					bodyClass: 'web-application'
				}
			}]
		},
		{
			path: '/kycdetail',
			component: PlainLayout,
			children: [{
				path: '',
				name: 'KYCDetail',
				component: KYCDetail,
				meta: {
					bodyClass: 'web-application'
				}
			}]
		},
		{
			path: '/ekycdetail',
			component: PlainLayout,
			children: [{
				path: '',
				name: 'EKYCDetail',
				component: EKYCDetail,
				meta: {
					bodyClass: 'web-application'
				}
			}]
		},

		{

			path: '/upgradetokyc/mobile/:token',
			// path: '/upgradetokyc',
			name: 'UpgradeToKYC',
			component: PlainLayout,
			children: [{
				path: '',
				name: 'UpgradeToKYCDetail',
				component: UpgradeToKYCDetail,
				props: true,
				meta: {
					bodyClass: 'web-application'
				}
			}]
		},
		{
			path: '/home',
			component: commercialDefaultLayout,
			children: [{
				path: '',
				name: 'home',
				component: CommercialHome,
				meta: {
					bodyClass: 'commercial-website',
					pagetype: 1
				}
			}]
		},

		{
			path: '/works',
			component: commercialDefaultLayout,
			children: [{
				path: '',
				name: 'Works',
				component: CommercialWorks,
				meta: {
					bodyClass: 'commercial-website',
					pagetype: 1
				}
			}]
		},
		{
			path: '/contact',
			component: commercialDefaultLayout,
			children: [{
				path: '',
				name: 'contact',
				component: CommercialContact,
				meta: {
					bodyClass: 'commercial-website',
					pagetype: 1
				}
			}]
		},

		{
			path: '/business',
			component: commercialDefaultLayout,
			children: [{
				path: '',
				name: 'business',
				component: CommercialBusiness,
				meta: {
					bodyClass: 'commercial-website',
					pagetype: 2
				}
			}]
		},
		{
			path: '/worksbiz',
			component: commercialDefaultLayout,
			children: [{
				path: '',
				name: 'worksbiz',
				component: CommercialWorksbiz,
				meta: {
					bodyClass: 'commercial-website',
					pagetype: 2
				}
			}]
		},
		{
			path: '/aboutus',
			component: commercialDefaultLayout,
			children: [{
				path: '',
				name: 'aboutus',
				component: CommercialAboutus,
				meta: {
					bodyClass: 'commercial-website',
					pagetype: 1
				}
			}]
		},
		{
			path: '/etar',
			component: commercialDefaultLayout,
			children: [{
				path: '',
				name: 'rate',
				component: CommercialRate,
				meta: {
					bodyClass: 'commercial-website',
					pagetype: 1
				}
			}]
		},
		{
			path: '/promotion',
			component: commercialDefaultLayout,
			children: [{
					path: '',
					name: 'promotion',
					props: true,
					component: CommercialPromotion,
					meta: {
						bodyClass: 'commercial-website'
					}
				},
				{
					path: ':id',
					name: 'promotion',
					props: true,
					component: CommercialPromotion,
					meta: {
						bodyClass: 'commercial-website'
					}
				},
			]
		},


		{
			path: '/privacy',
			name: 'privacy',
			redirect: '/privacy/personal',

			component: commercialDefaultLayout,
			children: [{
					path: 'personal',
					name: 'privacypersonal',
					component: CommercialPrivacy,

					meta: {
						pagetype: 1,
						bodyClass: 'commercial-website',
					}
				},
				{
					path: 'business',
					name: 'privacybusiness',
					component: PrivacyBusiness,
					meta: {
						pagetype: 2,
						bodyClass: 'commercial-website'
					}
				},
				{
					path: 'promotions',
					name: 'promotiontermsandconditions',
					component: PromotionTermsAndConditions,
					meta: {
						pagetype: 1,
						bodyClass: 'commercial-website'
					}
				},
			]
		}, {
			path: '/faq',
			name: 'faq',
			redirect: '/faq/personal',

			component: commercialDefaultLayout,
			children: [{
					path: 'personal',
					name: 'faqpersonal',
					component: CommercialFAQ,

					meta: {
						pagetype: 1,
						bodyClass: 'commercial-website',
					}
				},
				{
					path: 'business',
					name: 'faqbusiness',
					component: CommercialBusinessFAQ,
					meta: {
						pagetype: 2,
						bodyClass: 'commercial-website'
					}
				},

			]
		},
		{
			path: '/legal',
			name: 'legal',
			redirect: '/legal/securityalert',

			component: commercialDefaultLayout,
			children: [{
				path: 'securityalert',
				name: 'securityalert',
				component: LegalSecurityAwareness,

				meta: {
					pagetype: 1,
					bodyClass: 'commercial-website',
				}
			}, ]
		},

	]
})
